// npm

// css
import '../../scss/pages/page-reservation.scss';

// libs
import ShowroomSingle from '../_libs/ShowroomSingle';

// utils
import foundation from '../_utils/foundation';
foundation();

document.addEventListener('DOMContentLoaded', () => {
	ShowroomSingle();
});

window.addEventListener('load', () => {});
